/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import ReactGA from "react-ga";
import $ from "jquery";
import * as React from "react";
import { PreviewStoreProvider } from "gatsby-source-prismic";
import moment from 'moment';
import browserStorage from "@utils/browserStorage";

const getDataFormat = () =>{
  const lang = browserStorage.get("lang") || "en";
  switch (lang) {
    case 'de':
      return 'DD MMMM YYYY';
    case 'en':
    default:
      return 'MMMM DD, YYYY';
  }
}

ReactGA.initialize("UA-92628920-2");

moment.locale(browserStorage.get("lang") || "en");
// @ts-ignore
moment.defaultFormat = getDataFormat();

export const wrapRootElement = ({ element }) => (
  <PreviewStoreProvider initialEnabled={true}>{element}</PreviewStoreProvider>
);
